import { render, staticRenderFns } from "./platform_question_bank.vue?vue&type=template&id=3fcf8b16&scoped=true&"
import script from "./platform_question_bank.vue?vue&type=script&lang=js&"
export * from "./platform_question_bank.vue?vue&type=script&lang=js&"
import style0 from "./platform_question_bank.vue?vue&type=style&index=0&id=3fcf8b16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf8b16",
  null
  
)

export default component.exports